import Menu from 'Models/Menu';

export default [
  Menu.assetInformation,
  Menu.newOrganization,
  Menu.newUser,
  Menu.assetsHelp,
];
